<template>
  <div class="relative px-2 py-2">
    <div
      class="data-container rounded p-4 font-mono text-xs w-full whitespace-pre-wrap"
      :class="{ 'host-name-container': field === 'host_name' && isMXTable }"
    >
      <pre class="break-all whitespace-pre-wrap">{{ displayValue }}</pre>
      <button
        v-if="displayValue"
        @click="copyToClipboard"
        class="absolute right-3 top-3 secondary_color"
        title="Copy to clipboard"
      >
        <ThemeImage :icon="imageNames.COPY_GREY" />
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { message } from "ant-design-vue";
import { imageNames } from "@/src/constants/imageConstants.js";
import ThemeImage from "@/src/components/ThemeImage.vue";

const props = defineProps({
  row: { type: Object, required: true },
  field: { type: String, default: 'expected_record' },
});

const field = computed(() => props.field);

const isMXTable = computed(() => props.row && 'priority' in props.row);

const displayValue = computed(() => {
  if (!props.row || !props.row[props.field]) return "";
  return props.row[props.field];
});

const copyToClipboard = () => {
  navigator.clipboard
    .writeText(displayValue.value)
    .then(() => {
      const fieldName = props.field === 'host_name' ? 'Host name' : 'Expected DNS record';
      message.success(`${fieldName} successfully copied to clipboard`);
    })
    .catch((err) => {
      console.error("Failed to copy: ", err);
    });
};
</script>

<style scoped>
.break-all {
  word-break: break-all;
}

.data-container {
  background: var(--white-opacity-4);
  min-width: 200px;
}

.host-name-container {
  max-width: 200px;
  min-width: auto;
  word-wrap: break-word;
}
</style>
